import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ClientManage = () => {
  const [clients, setClients] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [requests, setRequests] = useState([]);
  const [activeTab, setActiveTab] = useState('clients');
  const [showAddForm, setShowAddForm] = useState(false);
  const [showBalanceForm, setShowBalanceForm] = useState(false);
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ customer_id: '', username: '', password: '' });
  const [balanceForm, setBalanceForm] = useState({ customer_id: '', currency_code: 'USD', amount: '', notes: '' });
  const [passwordForm, setPasswordForm] = useState({ password: '' });
  const [approveNotes, setApproveNotes] = useState('');
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const token = localStorage.getItem('token');

  const currencyList = ['IQD', 'USD', 'EUR', 'GBP', 'SAR', 'AED', 'TRY', 'CAD'];

  useEffect(() => {
    fetchClients();
    fetchCustomers();
    fetchRequests();
  }, []);

  const fetchClients = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/clients', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClients(res.data.clients);
    } catch (err) { console.error(err); }
  };

  const fetchCustomers = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/customers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomers(res.data.customers);
    } catch (err) { console.error(err); }
  };

  const fetchRequests = async () => {
    try {
      const res = await axios.get('https://app.hayahost.net/api/clients/requests', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRequests(res.data.requests);
    } catch (err) { console.error(err); }
  };

  const handleAddClient = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://app.hayahost.net/api/clients', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('تم إنشاء حساب الفرع بنجاح!');
      setShowAddForm(false);
      setForm({ customer_id: '', username: '', password: '' });
      fetchClients();
    } catch (err) {
      alert(err.response?.data?.message || 'خطأ في إنشاء الحساب');
    }
    setLoading(false);
  };

  const handleToggleStatus = async (id) => {
    try {
      const res = await axios.put(`https://app.hayahost.net/api/clients/${id}/toggle`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert(res.data.message);
      fetchClients();
    } catch (err) { console.error(err); }
  };

  const handleUnlock = async (id) => {
    try {
      await axios.put(`https://app.hayahost.net/api/clients/${id}/unlock`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('تم رفع الحظر بنجاح!');
      fetchClients();
    } catch (err) { console.error(err); }
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`https://app.hayahost.net/api/clients/${selectedClient.id}/password`, passwordForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('تم تحديث كلمة السر بنجاح!');
      setShowPasswordForm(false);
      setPasswordForm({ password: '' });
    } catch (err) { console.error(err); }
  };

  const handleAddBalance = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://app.hayahost.net/api/clients/add-balance', balanceForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('تم إضافة الرصيد بنجاح والفرع أصبح مديوناً!');
      setShowBalanceForm(false);
      setBalanceForm({ customer_id: '', currency_code: 'USD', amount: '', notes: '' });
      fetchClients();
    } catch (err) {
      alert(err.response?.data?.message || 'خطأ في إضافة الرصيد');
    }
    setLoading(false);
  };

  const handleApprove = async () => {
    try {
      await axios.put(
        `https://app.hayahost.net/api/clients/requests/${selectedRequest.id}/approve`,
        { notes: approveNotes },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('تمت المطابقة بنجاح!');
      setShowApproveModal(false);
      fetchRequests();
      fetchClients();
    } catch (err) {
      alert(err.response?.data?.message || 'خطأ في المطابقة');
    }
  };

  const handleReject = async (id) => {
    const notes = prompt('سبب الرفض:');
    if (!notes) return;
    try {
      await axios.put(
        `https://app.hayahost.net/api/clients/requests/${id}/reject`,
        { notes },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('تم رفض الطلب!');
      fetchRequests();
    } catch (err) { console.error(err); }
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.toLocaleDateString('ar-IQ')} ${d.toLocaleTimeString('ar-IQ', {hour: '2-digit', minute: '2-digit'})}`;
  };

  const getStatusBadge = (status) => {
    switch(status) {
      case 'pending': return { text: '⏳ بانتظار المطابقة', bg: '#fff3e0', color: '#e65100' };
      case 'approved': return { text: '✅ تمت المطابقة', bg: '#e8f5e9', color: '#2e7d32' };
      case 'rejected': return { text: '❌ مرفوض', bg: '#ffebee', color: '#c62828' };
      default: return { text: status, bg: '#f5f5f5', color: '#666' };
    }
  };

  const pendingCount = requests.filter(r => r.status === 'pending').length;

  return (
    <div style={styles.container}>
      <div style={styles.navbar}>
        <h1 style={styles.navTitle}>🏦 نظام الحوالات والصيرفة</h1>
        <button style={styles.logoutBtn} onClick={() => { localStorage.clear(); window.location.href = '/login'; }}>خروج</button>
      </div>

      <div style={styles.layout}>
        <div style={styles.sidebar}>
          <a href="/" style={styles.sideItem}>🏠 الرئيسية</a>
          <a href="/customers" style={styles.sideItem}>👥 العملاء</a>
          <a href="/transfers" style={styles.sideItem}>💸 الحوالات</a>
          <a href="/exchange" style={styles.sideItem}>💱 الصرافة</a>
          <a href="/debts" style={styles.sideItem}>📋 المديونيات</a>
          <a href="/treasury" style={styles.sideItem}>🏛️ القاصة</a>
          <a href="/accounts" style={styles.sideItem}>📒 حسابات العملاء</a>
          <a href="/reports" style={styles.sideItem}>📊 التقارير</a>
          <a href="/clients" style={{...styles.sideItem, background: '#e3f2fd', color: '#1a237e', fontWeight: 'bold'}}>
            🔐 إدارة الفروع
            {pendingCount > 0 && <span style={styles.badge}>{pendingCount}</span>}
          </a>
        </div>

        <div style={styles.content}>

          {/* نافذة المطابقة */}
          {showApproveModal && selectedRequest && (
            <div style={styles.modalOverlay}>
              <div style={styles.modal}>
                <h3 style={styles.modalTitle}>✅ مطابقة الطلب</h3>
                <div style={styles.modalDetails}>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>من</span>
                    <span style={styles.modalValue}>{selectedRequest.from_customer_name}</span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>إلى</span>
                    <span style={styles.modalValue}>{selectedRequest.to_customer_name}</span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>نوع الطلب</span>
                    <span style={{...styles.modalValue, color: selectedRequest.type === 'pay_to_main' ? '#2e7d32' : '#1a237e'}}>
                      {selectedRequest.type === 'pay_to_main' ? '💰 تسديد للرئيسي' : '💸 تحويل'}
                    </span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>المبلغ</span>
                    <span style={{...styles.modalValue, color: '#1a237e', fontSize: '18px', fontWeight: 'bold'}}>
                      {parseFloat(selectedRequest.amount).toLocaleString()} {selectedRequest.currency_code}
                    </span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>الرقم المرجعي</span>
                    <span style={styles.modalValue}>{selectedRequest.reference_number}</span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>التاريخ</span>
                    <span style={styles.modalValue}>{formatDateTime(selectedRequest.created_at)}</span>
                  </div>
                  {selectedRequest.notes && (
                    <div style={styles.modalRow}>
                      <span style={styles.modalLabel}>ملاحظات الفرع</span>
                      <span style={styles.modalValue}>{selectedRequest.notes}</span>
                    </div>
                  )}
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>ملاحظات المطابقة</label>
                  <textarea style={{...styles.input, height: '70px', resize: 'vertical'}}
                    value={approveNotes} onChange={e => setApproveNotes(e.target.value)}
                    placeholder="أي ملاحظات..." />
                </div>
                <div style={styles.modalButtons}>
                  <button style={styles.approveBtn} onClick={handleApprove}>✅ تأكيد المطابقة</button>
                  <button style={styles.cancelBtn} onClick={() => setShowApproveModal(false)}>إلغاء</button>
                </div>
              </div>
            </div>
          )}

          {/* نافذة تغيير كلمة السر */}
          {showPasswordForm && selectedClient && (
            <div style={styles.modalOverlay}>
              <div style={styles.modal}>
                <h3 style={styles.modalTitle}>🔑 تغيير كلمة السر</h3>
                <p style={{color: '#666', marginBottom: '15px'}}>العميل: {selectedClient.customer_name}</p>
                <form onSubmit={handleUpdatePassword}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>كلمة السر الجديدة</label>
                    <input style={styles.input} type="password" value={passwordForm.password}
                      onChange={e => setPasswordForm({password: e.target.value})}
                      placeholder="كلمة السر الجديدة" required />
                  </div>
                  <div style={styles.modalButtons}>
                    <button style={styles.approveBtn} type="submit">💾 حفظ</button>
                    <button style={styles.cancelBtn} type="button" onClick={() => setShowPasswordForm(false)}>إلغاء</button>
                  </div>
                </form>
              </div>
            </div>
          )}

          <div style={styles.header}>
            <h2 style={styles.pageTitle}>🔐 إدارة الفروع</h2>
            <div style={{display: 'flex', gap: '10px'}}>
              <button style={styles.balanceBtn} onClick={() => setShowBalanceForm(!showBalanceForm)}>
                💰 إضافة رصيد لفرع
              </button>
              <button style={styles.addBtn} onClick={() => setShowAddForm(!showAddForm)}>
                {showAddForm ? 'إلغاء' : '+ إضافة فرع جديد'}
              </button>
            </div>
          </div>

          {/* نموذج إضافة فرع */}
          {showAddForm && (
            <div style={styles.formCard}>
              <h3 style={styles.formTitle}>إضافة حساب فرع جديد</h3>
              <form onSubmit={handleAddClient}>
                <div style={styles.formGrid}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>العميل / الشركة</label>
                    <select style={styles.input} value={form.customer_id}
                      onChange={e => setForm({...form, customer_id: e.target.value})} required>
                      <option value="">-- اختر --</option>
                      {customers.map(c => (
                        <option key={c.id} value={c.id}>
                          {c.customer_type === 'company' ? '🏢' : '👤'} {c.name} - {c.phone}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>اسم المستخدم</label>
                    <input style={styles.input} value={form.username}
                      onChange={e => setForm({...form, username: e.target.value})}
                      placeholder="username" required />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>كلمة السر</label>
                    <input style={styles.input} type="password" value={form.password}
                      onChange={e => setForm({...form, password: e.target.value})}
                      placeholder="كلمة السر" required />
                  </div>
                </div>
                <button style={styles.submitBtn} type="submit" disabled={loading}>
                  {loading ? 'جاري الحفظ...' : '💾 إنشاء الحساب'}
                </button>
              </form>
            </div>
          )}

          {/* نموذج إضافة رصيد */}
          {showBalanceForm && (
            <div style={{...styles.formCard, borderRight: '4px solid #2e7d32'}}>
              <h3 style={{...styles.formTitle, color: '#2e7d32'}}>💰 إضافة رصيد لفرع</h3>
              <p style={{color: '#666', fontSize: '13px', marginBottom: '15px'}}>
                ⚠️ عند إضافة رصيد سيصبح الفرع مديوناً بهذا المبلغ
              </p>
              <form onSubmit={handleAddBalance}>
                <div style={styles.formGrid}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>العميل / الشركة</label>
                    <select style={styles.input} value={balanceForm.customer_id}
                      onChange={e => setBalanceForm({...balanceForm, customer_id: e.target.value})} required>
                      <option value="">-- اختر --</option>
                      {clients.map(c => (
                        <option key={c.customer_id} value={c.customer_id}>
                          {c.customer_type === 'company' ? '🏢' : '👤'} {c.customer_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>العملة</label>
                    <select style={styles.input} value={balanceForm.currency_code}
                      onChange={e => setBalanceForm({...balanceForm, currency_code: e.target.value})}>
                      {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>المبلغ</label>
                    <input style={styles.input} type="number" value={balanceForm.amount}
                      onChange={e => setBalanceForm({...balanceForm, amount: e.target.value})}
                      placeholder="0" required />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>ملاحظات</label>
                    <input style={styles.input} value={balanceForm.notes}
                      onChange={e => setBalanceForm({...balanceForm, notes: e.target.value})}
                      placeholder="سبب إضافة الرصيد" />
                  </div>
                </div>
                <button style={{...styles.submitBtn, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)'}} type="submit" disabled={loading}>
                  {loading ? 'جاري الإضافة...' : '💰 إضافة الرصيد'}
                </button>
              </form>
            </div>
          )}

          {/* تبويبات */}
          <div style={styles.tabs}>
            <button style={activeTab === 'clients' ? styles.tabActive : styles.tabBtn}
              onClick={() => setActiveTab('clients')}>
              👥 الفروع ({clients.length})
            </button>
            <button style={activeTab === 'requests' ? styles.tabActive : styles.tabBtn}
              onClick={() => { setActiveTab('requests'); fetchRequests(); }}>
              📋 الطلبات
              {pendingCount > 0 && <span style={styles.badge}>{pendingCount}</span>}
            </button>
          </div>

          {/* قائمة الفروع */}
          {activeTab === 'clients' && (
            <div style={styles.tableCard}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableHead}>
                    <th style={styles.th}>العميل / الشركة</th>
                    <th style={styles.th}>اسم المستخدم</th>
                    <th style={styles.th}>الأرصدة</th>
                    <th style={styles.th}>آخر دخول</th>
                    <th style={styles.th}>الحالة</th>
                    <th style={styles.th}>إجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {clients.map((c, i) => (
                    <tr key={c.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                      <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e'}}>
                        {c.customer_type === 'company' ? '🏢' : '👤'} {c.customer_name}
                        <div style={{fontSize: '11px', color: '#666'}}>{c.phone}</div>
                      </td>
                      <td style={styles.td}>
                        <span style={styles.usernameBadge}>{c.username}</span>
                      </td>
                      <td style={styles.td}>
                        {c.balances && c.balances.length > 0 ? (
                          <div style={{display: 'flex', flexWrap: 'wrap', gap: '4px'}}>
                            {c.balances.map((b, j) => (
                              <span key={j} style={{
                                background: parseFloat(b.balance) >= 0 ? '#e8f5e9' : '#ffebee',
                                color: parseFloat(b.balance) >= 0 ? '#2e7d32' : '#c62828',
                                padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 'bold'
                              }}>
                                {parseFloat(b.balance).toLocaleString()} {b.currency}
                              </span>
                            ))}
                          </div>
                        ) : <span style={{color: '#999', fontSize: '12px'}}>لا يوجد رصيد</span>}
                      </td>
                      <td style={{...styles.td, fontSize: '11px', color: '#666'}}>
                        {c.last_login ? formatDateTime(c.last_login) : 'لم يدخل بعد'}
                      </td>
                      <td style={styles.td}>
                        <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
                          <span style={{
                            background: c.is_active ? '#e8f5e9' : '#ffebee',
                            color: c.is_active ? '#2e7d32' : '#c62828',
                            padding: '3px 8px', borderRadius: '10px', fontSize: '11px', textAlign: 'center'
                          }}>
                            {c.is_active ? '✅ نشط' : '❌ معطل'}
                          </span>
                          {c.is_locked && (
                            <span style={{background: '#ffebee', color: '#c62828', padding: '3px 8px', borderRadius: '10px', fontSize: '11px', textAlign: 'center'}}>
                              🔒 محظور ({c.failed_attempts} محاولة)
                            </span>
                          )}
                        </div>
                      </td>
                      <td style={styles.td}>
                        <div style={{display: 'flex', gap: '4px', flexWrap: 'wrap'}}>
                          <button style={styles.editBtn}
                            onClick={() => { setSelectedClient(c); setShowPasswordForm(true); }}>
                            🔑 كلمة السر
                          </button>
                          <button style={{
                            ...styles.toggleBtn,
                            background: c.is_active ? '#c62828' : '#2e7d32'
                          }} onClick={() => handleToggleStatus(c.id)}>
                            {c.is_active ? '🚫 تعطيل' : '✅ تفعيل'}
                          </button>
                          {c.is_locked && (
                            <button style={{...styles.toggleBtn, background: '#1a237e'}}
                              onClick={() => handleUnlock(c.id)}>
                              🔓 رفع الحظر
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {clients.length === 0 && <div style={styles.empty}>لا يوجد فروع مسجلة</div>}
            </div>
          )}

          {/* الطلبات */}
          {activeTab === 'requests' && (
            <div style={styles.tableCard}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableHead}>
                    <th style={styles.th}>الرقم المرجعي</th>
                    <th style={styles.th}>من</th>
                    <th style={styles.th}>إلى</th>
                    <th style={styles.th}>النوع</th>
                    <th style={styles.th}>المبلغ</th>
                    <th style={styles.th}>ملاحظات</th>
                    <th style={styles.th}>التاريخ</th>
                    <th style={styles.th}>الحالة</th>
                    <th style={styles.th}>إجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.map((r, i) => {
                    const status = getStatusBadge(r.status);
                    return (
                      <tr key={r.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                        <td style={{...styles.td, fontSize: '11px', color: '#1a237e'}}>{r.reference_number}</td>
                        <td style={{...styles.td, fontWeight: 'bold'}}>
                          {r.from_customer_type === 'company' ? '🏢' : '👤'} {r.from_customer_name}
                        </td>
                        <td style={styles.td}>
                          {r.to_customer_name === 'الرئيسي' ? '🏦 الرئيسي' : 
                            `${r.to_customer_type === 'company' ? '🏢' : '👤'} ${r.to_customer_name}`}
                        </td>
                        <td style={styles.td}>
                          {r.type === 'pay_to_main' ? 
                            <span style={{color: '#2e7d32', fontWeight: 'bold'}}>💰 تسديد للرئيسي</span> : 
                            <span style={{color: '#1a237e'}}>💸 تحويل</span>
                          }
                        </td>
                        <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e'}}>
                          {parseFloat(r.amount).toLocaleString()} {r.currency_code}
                        </td>
                        <td style={{...styles.td, fontSize: '12px', color: '#666'}}>{r.notes || '-'}</td>
                        <td style={{...styles.td, fontSize: '11px'}}>{formatDateTime(r.created_at)}</td>
                        <td style={styles.td}>
                          <span style={{background: status.bg, color: status.color, padding: '4px 10px', borderRadius: '20px', fontSize: '11px'}}>
                            {status.text}
                          </span>
                        </td>
                        <td style={styles.td}>
                          {r.status === 'pending' && (
                            <div style={{display: 'flex', gap: '4px'}}>
                              <button style={styles.approveActionBtn}
                                onClick={() => { setSelectedRequest(r); setApproveNotes(''); setShowApproveModal(true); }}>
                                ✅ مطابقة
                              </button>
                              <button style={styles.rejectBtn}
                                onClick={() => handleReject(r.id)}>
                                ❌ رفض
                              </button>
                            </div>
                          )}
                          {r.status !== 'pending' && (
                            <div style={{fontSize: '11px', color: '#666'}}>
                              {formatDateTime(r.approved_at)}
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {requests.length === 0 && <div style={styles.empty}>لا توجد طلبات</div>}
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#f5f5f5' },
  navbar: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  navTitle: { color: 'white', fontSize: '20px' },
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' },
  layout: { display: 'flex' },
  sidebar: { width: '200px', background: 'white', minHeight: 'calc(100vh - 60px)', padding: '20px 0', boxShadow: '2px 0 5px rgba(0,0,0,0.1)' },
  sideItem: { display: 'block', padding: '12px 20px', color: '#333', textDecoration: 'none', fontSize: '14px', borderBottom: '1px solid #f0f0f0', position: 'relative' },
  badge: { background: '#c62828', color: 'white', borderRadius: '50%', padding: '2px 6px', fontSize: '10px', marginRight: '5px', fontWeight: 'bold' },
  content: { flex: 1, padding: '30px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  pageTitle: { color: '#1a237e', fontSize: '22px' },
  addBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  balanceBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  formCard: { background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  formTitle: { marginBottom: '15px', color: '#1a237e' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' },
  inputGroup: { marginBottom: '10px' },
  label: { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: 'bold' },
  input: { width: '100%', padding: '10px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl' },
  submitBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  tabs: { display: 'flex', gap: '8px', marginBottom: '20px' },
  tabBtn: { background: '#f5f5f5', border: '1px solid #e0e0e0', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', color: '#666', position: 'relative' },
  tabActive: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold', position: 'relative' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'auto', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHead: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'right', fontSize: '13px', whiteSpace: 'nowrap' },
  trEven: { background: 'white' },
  trOdd: { background: '#f8f9fa' },
  td: { padding: '10px 15px', fontSize: '13px', borderBottom: '1px solid #f0f0f0' },
  usernameBadge: { background: '#e3f2fd', color: '#1a237e', padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' },
  editBtn: { background: '#e65100', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  toggleBtn: { color: 'white', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  approveActionBtn: { background: '#2e7d32', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  rejectBtn: { background: '#c62828', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  empty: { textAlign: 'center', padding: '40px', color: '#999' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: 'white', borderRadius: '16px', padding: '30px', width: '500px', maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' },
  modalTitle: { color: '#1a237e', marginBottom: '20px', fontSize: '18px', borderBottom: '2px solid #e3f2fd', paddingBottom: '10px' },
  modalDetails: { background: '#f8f9fa', borderRadius: '10px', padding: '15px', marginBottom: '20px' },
  modalRow: { display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e0e0e0' },
  modalLabel: { color: '#666', fontSize: '13px' },
  modalValue: { color: '#1a237e', fontWeight: 'bold', fontSize: '13px' },
  modalButtons: { display: 'flex', gap: '10px', marginTop: '20px' },
  approveBtn: { flex: 1, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  cancelBtn: { flex: 1, background: '#f5f5f5', color: '#666', border: '1px solid #e0e0e0', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
};

export default ClientManage;